import { Metamodel } from '../base/model';
import { IModel, IAttribute } from '../base/annotation';
import { Owned } from '../base/named';
import { ParameterConfig } from '../pipeline/parameter-config';
import { format } from '../../shared/utils/string.util';
import { shellStringResources as stringResources } from '../../Resources/ShellStringResources';

@Metamodel.model({
    display: [stringResources.ImportOrExportSettings_Label]
})
export class ImportExportSettings extends Owned {
    public static readonly MODEL: IModel;
    public static readonly ADDITIONAL_COPYOPTIONS: IAttribute;
    public static readonly ADDITIONAL_FORMATOPTIONS: IAttribute;
    public static readonly STORAGE_INTEGRATION: IAttribute;

    @Metamodel.attribute({
        templatable: true,
        association: 'ADDITIONAL_COPYOPTIONS',
        display: format(stringResources.Additional_CopyOptions_Label, ''),
        accepts: ['Object', 'Array']
    })
    public additionalCopyOptions: ParameterConfig[] = [];

    @Metamodel.attribute({
        templatable: true,
        association: 'ADDITIONAL_FORMATOPTIONS',
        display: format(stringResources.Additional_FormatOptions_Label, ''),
        accepts: ['Object', 'Array']
    })
    public additionalFormatOptions: ParameterConfig[] = [];

    @Metamodel.attribute({
        templatable: true,
        association: 'STORAGE_INTEGRATION',
        display: stringResources.StorageIntegration_Label,
        accepts: ['String']
    })
    public storageIntegration?: string;
}
